<template lang="html">
  <div id="offers-page">

    <section class="main-section" data-aos="fade-in" data-aos-duration="1000">
      <div class="container med-container">
        <div class="row">
          <div class="col-12 col-title">
            <h2 class="title-s1">BLOG</h2>
          </div>

          <div class="col-12 col-results">
            <div class="row">
              <div class="col-lg-6 box-article-s1" v-for="(a, aInx) in blogs" :key="'aInx-'+aInx">
                <router-link class="box" :to="'/blog/'+a.id">
                  <div class="placed-backg box-image" v-bind:style="{ backgroundImage: 'url('+a.imageUrl+')' }"></div>

                  <div class="box-info">
                    <h5 class="title">{{ a.title }}</h5>

                    <div class="b-text" v-html="a.body_cut"></div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data(){
    return{
      blogs:[],
    }
  },

  methods: {
    getRow: function(){
        axios.get(tools.url('/api/blogs')).then((response)=>{
            this.blogs = response.data;
        });
    }
  },

  mounted(){
    this.getRow();
  }
}
</script>
